import styled from '@emotion/styled'
import {
  baseStyle,
  h1Style,
  h2Style,
  h3Style,
  pStyle,
  smallPStyle,
  labelStyle,
} from 'src/constants/fontStyles'

export const H1 = styled.h1`
  ${baseStyle};
  ${h1Style};
`

export const H2 = styled.h2`
  ${baseStyle};
  ${h2Style};
`

export const H3 = styled.h3`
  ${baseStyle};
  ${h3Style};
`

export const P1 = styled.div`
  ${baseStyle};
  ${pStyle};
`

// TODO: need to be placed in the Label component instead
export const P1Bold = styled.div`
  ${baseStyle};
  ${labelStyle};
`

export const SmallP = styled.div`
  ${baseStyle};
  ${smallPStyle}
`

// TODO: never been used in design-system, need to be clean up
export const H4 = styled.h4`
  ${baseStyle};
  ${labelStyle};
`
